import { EnumProductType } from '@/types/enum-product-type'

export function getProductType(product_type: EnumProductType): string {
  const productTypeMap: Record<EnumProductType, string> = {
    [EnumProductType.COURSE]: 'Curso Online',
    [EnumProductType.MENTORSHIP]: 'Mentoria',
    [EnumProductType.POSTGRADUATE]: 'Pós-Graduação',
    [EnumProductType.PERSONALIZED]: 'Personalizado',
    [EnumProductType.TRACK]: 'Trilha',
    [EnumProductType.EXCLUSIVE]: 'Exclusivo',
    [EnumProductType.WEBINAR]: 'Webinar',
    [EnumProductType.EXTRA_MATERIAL]: 'Material Extra',
  }

  return productTypeMap[product_type as EnumProductType]
}
